import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

import { type Look, lookProps, lookSurface } from '@/entities/appearance';

import styles from './editor.module.css';

interface Props {
  look: Look | null;
  /** Shown above the sample ("Preview"). */
  label?: string;
  children?: ReactNode;
}

/**
 * A miniature card painted by the real look CSS. It shows what the system states look like
 * on top of the look (label strip, overdue pill), because a look never replaces them.
 */
export function LookPreview({ look, label, children }: Props) {
  const { t } = useTranslation();
  return (
    <div className={styles.previewBox} data-testid="look-preview">
      <span className={styles.previewLabel}>{label ?? t('appearance.preview')}</span>
      <div className={`${styles.sampleCard} ${lookSurface ?? ''}`} {...lookProps(look)}>
        <span className={styles.sampleLabel} aria-hidden />
        {children ?? (
          <>
            <strong>{t('appearance.sampleTitle')}</strong>
            <span className={styles.sampleLine} aria-hidden />
            <span className={styles.sampleBadges}>
              <span className={styles.samplePill}>{t('appearance.sampleOverdue')}</span>
            </span>
          </>
        )}
      </div>
    </div>
  );
}
